// MuiDatePickerField.jsx
import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

const MuiDatePickerField = ({
  label,
  name,
  value,
  onChange,
  disableFuture = true,
  ...props
}) => {
  // Convert raw value (string or null) to Dayjs object for the picker
  const dayjsValue = value ? dayjs(value) : null;

  const handleChange = (newValue) => {
    if (onChange) {
      // Send the raw date string in YYYY-MM-DD format to formData
      onChange({
        target: {
          name,
          value: newValue ? newValue.format("YYYY-MM-DD") : "",
        },
      });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={dayjsValue}
        onChange={handleChange}
        disableFuture={disableFuture}
        inputFormat="MM-DD-YYYY" // This ensures UI always shows MM-DD-YYYY
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            size="small"
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default MuiDatePickerField;
